import type { FaireProductEntity } from "../../entity_types/product";

export const p_3s0nl3yzqm: FaireProductEntity = {
  token: "p_3s0nl3yzqm",
  type: "product",
  name: "Hawaiian Dreams Round White Puka Shell Anklet",
  brandName: "ZAD",
  imageUrl:
    "https://cdn.faire.com/fastly/d2898b21cb4447c3cb0c9400ae50d2e8b131fa75027510cf4cf7ba4ea3d38258.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/90952c1478ae719dff9726b435b83b0a77bac11b41dcc5c2c33a70f247e45f7c.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
